import { SET_CUSTOM_FIELD_2 } from 'actions';

export function setCustomField2(sourceType: string) {
  return { sourceType, type: SET_CUSTOM_FIELD_2 };
}
